import styled from "styled-components";
import { mainText, extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["space", "layout", "color", "typography", "flexbox"];
export default styled.h2.withConfig({
  displayName: "ModuleHeader",
  componentId: "sc-1wh805c-0"
})(["", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    ".concat(mainText(theme), "\n    font-family: ").concat(theme.fonts.robotoRegular, ";\n    padding: 15px 20px;\n    background: ").concat(theme.colors.P3, ";\n    color: ").concat(theme.colors.G1, ";\n    margin: 0;\n  ");
}, extendedSystemStyles(styledSystemKeys));